import CreditCard, { CREDIT_CARD_FIELD_NAMES } from './component';
import CreditCardWithForm, { PAY_FORM } from './container/CreditCardWithForm';
import cardFieldsValidate from './container/validation';
import { CardIcon } from './component/blocks/CardIcon/CardIcon';

const constants = {
  PAY_FORM,
  CREDIT_CARD_FIELD_NAMES,
};

export { CreditCard, CreditCardWithForm, cardFieldsValidate, constants, CardIcon };
